// import { ExpenseCategoryList } from "components/ExpenseCategory";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { ExpenseCategoryList } from "../../components/ExpenseCategoryList";


export interface IExpenseCategoryListPage {}

export const ExpenseCategoryListPage: FC<IExpenseCategoryListPage> = (
  props: IExpenseCategoryListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Expense Category List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Expense Category", navigateTo: "/company/expense-category/list" },
      ]}
      mainContents={<ExpenseCategoryList />}
    />
  );
};
